import React from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { ToggleButtonProps } from "../../../../types";
import useToggleStyles from "./styles";

const ToggleButton: React.FC<ToggleButtonProps> = (props) => {
    const { style, labelText, handleChange, defaultChecked } = props;
    const toggleStyles = useToggleStyles();

  return (
    <Form style={toggleStyles.formContainer}>
      <FormGroup switch>
        <Input type="switch" style={{ ...style ,...(defaultChecked ? toggleStyles.toggle:toggleStyles.inActiveToggle)}} 
          checked={defaultChecked} onChange={handleChange} />
        <Label check>{labelText}</Label>
      </FormGroup>
    </Form>
  );
};

export default ToggleButton;
